module.exports = __webpack_public_path__ + "img/activeProgress.bc0dc51c.svg";